import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagBF = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M0 25C0 11.193 11.193 0 25 0s25 11.193 25 25c-1.087 0-25 3.26-25 3.26L0 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M50 25c0 13.807-11.193 25-25 25S0 38.807 0 25"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "m25 16.304 1.888 5.813H33l-4.945 3.592 1.889 5.813L25 27.929l-4.945 3.593 1.889-5.813-4.945-3.592h6.112L25 16.304Z"
}));
FlagBF.displayName = 'FlagBF';
export default withFlagWrapper(FlagBF);
//# sourceMappingURL=index.js.map